import React from 'react';
import ENDPOINTS from '../../../../constants/endpoints';
import SearchTable from '../../../../components/admin/SearchTable';

const columns = [
    {title: 'Cliente', dataIndex: 'client_name', key: 'client_name'},
    {title: 'Pedidos', dataIndex: 'order_count', key: 'order_count'},
    {
        title: 'Média de Dias Entre Pedidos',
        dataIndex: 'avg_days_between_orders',
        key: 'avg_days_between_orders',
        render: (value) => (value == null ? '-' : value),
    },
];

// DRF page-paginado — reusa SearchTable diretamente, igual AdminOrderList.
// Sem `search` documentado na API, então showSearch fica desligado.
export default function FrequencyDetailTable({dateFrom, dateTo}) {
    return (
        <SearchTable
            key={`${dateFrom}-${dateTo}`}
            url={ENDPOINTS.REPORTS_ECOMMERCE_FREQUENCY_DETAIL}
            params={{date_from: dateFrom, date_to: dateTo}}
            columns={columns}
            rowKey="client_id"
            title="Detalhe de Frequência por Cliente"
            showSearch={false}
        />
    );
}
